import ThisModule from "./ModalWizard";

export default ThisModule;
